import React from "react";
import Grid from "@material-ui/core/Grid";
import { styled } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Electrician from "../Images/Electrician.jpg";
import Ac from '../Images/AC.jpeg'
import Fridge from '../Images/Fridge.jpeg'
import Tv from '../Images/TV.jpeg'
import WashingMachine from '../Images/wahingmachine.jpeg'
import Microwave from '../Images/microwave.jpeg'
import Carpenter from "../Images/carpenter.jpg";
import Plumber from "../Images/plumber.jpg";
import Filter from '../Images/filter.jpg'
import { Link, useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import "./quickMenu.css";
const Wrapper = styled("section")({
  width: "100%",
  height: "max-content",
  display: "flex",
  alignItems: "center",
  minHeight: "600px",
  justifyContent: "center",
  flexDirection: "row",
  backgroundColor: "#e1ad01",
  padding: "50px 30px 50px 30px"
});


export const Cardcomponent = ({ item }) => {
  return (
      <Grid item xs={12} sm={6} md={4} style={{maxWidth:'400px'}}>
        <div className="overlay">
          <Link to={{
            pathname:'/aboutservice',
            state:{
              category:`${item.link}`           }
          }}>
            <span className="quickmenuname">
              <Typography variant={"h5"} style={{textAlign:'center'}}>{item.name}
                </Typography>
              </span>
            <img
                src={item.image}
                className="quickmenunimage"
                alt={item.name + ".jpg"}
            />
          </Link>
        </div>
      </Grid>
  );
};

const Quickmenu = () => {
  const data = [
    { name: "Electrician", image: Electrician, link: "electrician" },
    { name: "Plumbing", image: Plumber, link: "plumbing" },
    { name: "Carpentry", image: Carpenter, link: "carpentery" },
    { name: "AC", image: Ac, link: "ac" },
    { name: "Ro/Filter", image: Filter, link: "ro/filter" },
    { name: "TV", image: Tv, link: "tv" },
    { name: "Fridge", image: Fridge, link: "fridge" },
    { name: "Washing Machine", image: WashingMachine, link: "washing-machine" },
    { name: "Microwave", image: Microwave, link: "microwave" },
  ];
  return (
      <Wrapper>
        <Grid container spacing={3} style={{maxWidth:'1200px'}}>
          {data.map((items) => {
            return <Cardcomponent key={items.name} item={items} />;
          })}
        </Grid>
      </Wrapper>
  );
};
export default Quickmenu;
